import { CurrencyRialIcon } from './CurrencyRialIcon';

/**
 * author: Haley Halcyon
 * id 55D42287-2705-451B-B87A-91C23AF3A945
 * name currency-rial
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-rial.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const CurrencyOmrIcon = CurrencyRialIcon;
export default CurrencyOmrIcon